const generateLogin = (userForm = {}) => {
  const { user, passport } = userForm;
  const [year] = passport.date_of_birth.split("-");
  const surname = user.surname.toLowerCase();
  const login = `${surname}${year}`;
  return login;
};

export const generators = {
  generateLogin,
};



// WEBPACK FOOTER //
// ./src/user/utils/generators.js